<template>
  <fragment v-if="userAlowed">
    <slot />
  </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import check from "./check";
import getMatchers from "./getMatchers";

export default {
  name: "Acl",
  components: { Fragment },
  props: {
    permissions: {
      type: Array,
      default: () => []
    },
    roles: {
      type: Array,
      default: () => []
    },
    features: {
      type: Array,
      default: () => []
    },
    tier: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    data() {
      const matchers = getMatchers({
        roles: this.roles,
        permissions: this.permissions,
        features: this.features,
        tier: this.tier
      });

      return {
        matchers
      };
    },
    userAlowed() {
      const thereIsRule = [
        this.permissions,
        this.roles,
        this.features,
        this.tier
      ].some(routeRule => {
        return routeRule && routeRule.length;
      });

      if (!thereIsRule) {
        return true;
      }

      return check(this.data.matchers);
    }
  }
};
</script>

<style></style>
